export default __webpack_public_path__ + "static/media/arrow.9ba86e32.svg";